<div class="sip-address-wrapper">
  <mat-form-field
    appearance="outline"
    class="field-wrapper"
    [style]="fieldStyle"
    subscriptSizing="dynamic"
  >
    <input
      [formControl]="controlValue"
      [attr.data-cy]="E2eLocators.CONTROLS_SIP_ADDRESS"
      matInput
      type="text"
      autocomplete="off"
    />
    <mat-error>
      @if (errorMessage$ | async; as errorMessage) {
      {{ errorMessage }}
      }
    </mat-error>
  </mat-form-field>
  <span class="suffix" id="suffix" matSuffix>&#64;{{ domain$ | async }}</span>
</div>
